

// Banner Slider
if($(document).find(".banner_slider").length > 0){
  $('.banner_slider').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    arrows: true
  });
}

if($(document).find(".testimonail").length > 0){
  $('.testimonail').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
}

if($(document).find(".featured_collection_slider").length > 0){
  $('.featured_collection_slider').slick({
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 3.5,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2.5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
}

if($(document).find(".column_slide").length > 0){
  $('.column_slide').slick({
    slidesToShow: 7,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    autoplaySpeed: 2000,
     responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });
}
if($(document).find(".main_product_slider").length > 0){
  var mainSlider = $('.slide_mainP .main_product_slider');
  var thumbnailSlider = $('.slide_thumnP .thumbnail_product-slide');
  mainSlider.on('swipe', function(event, slick, direction){
     if (direction === 'left' || direction === 'right') {
      thumbnailSlider.slick('slickSetOption', 'swipe', false, true);
      }
  });
  mainSlider.on('afterChange', function(event, slick, currentSlide){
      thumbnailSlider.slick('slickSetOption', 'swipe', true, true);
  });
}

if($(document).find(".main_product_slider").length > 0){
  
  $('.main_product_slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.thumbnail_product-slide'
  });
}

if($(document).find(".thumbnail_product-slide").length > 0){
  $('.thumbnail_product-slide').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.main_product_slider',
    dots: false,
    arrows: true,
    centerMode: false,
    focusOnSelect: true,
    vertical: true,
    prevArrow:'<button type="button" class="slick-arrow slick-prev"><svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></svg></button>',
    nextArrow:'<button type="button" class="slick-arrow slick-next"><svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></svg></button>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          vertical: true
        }
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          vertical: false
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          vertical: false
        }
      }
    ]
  });

}



if($(document).find('.template-product').length > 0 && document.querySelector(".product__info-container noscript")){
  var noscript_tag = document.querySelectorAll(".product__info-container noscript")[0];
  var nosHtml = noscript_tag.textContent||noscript_tag.innerHTML; 
  var currentVariant = $(nosHtml).find('.select__select option:selected ').data('media');
   $(document).find('.thumbnail_product-slide li').each(function(){
  var dataMedia = $(this).data('media');
  if(currentVariant == dataMedia){
    var indexData = $(this).data('index');
    $('.thumbnail_product-slide').slick('slickGoTo', indexData);
  }
  });

}


document.addEventListener("DOMContentLoaded", function() {
  var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));
  if ("IntersectionObserver" in window) {
    var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(video) {
        if (video.isIntersecting) {
          for (var source in video.target.children) {
            var videoSource = video.target.children[source];
            if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
              videoSource.src = videoSource.dataset.src;
            }
          }

          video.target.load();
          video.target.classList.remove("lazy");
          lazyVideoObserver.unobserve(video.target);
        }
      });
    });

    lazyVideos.forEach(function(lazyVideo) {
      lazyVideoObserver.observe(lazyVideo);
    });
  }
});

/* Charger dropdown fix (Oct 8 2026): the visible charger dropdown (.ctm-option-2-main select) must tick the hidden charger radio, otherwise the cart gets the USA variant instead of EU/UK. */
(function(){function hiddenRadios(sel){var picker=sel.closest('variant-radios, variant-selects');var fs=picker&&picker.querySelector('fieldset[data-index="2"]');return fs?Array.prototype.slice.call(fs.querySelectorAll('input[type="radio"]')):[];}document.addEventListener('change',function(e){var sel=e.target;if(!sel.matches||!sel.matches('.ctm-option-2-main select'))return;hiddenRadios(sel).forEach(function(r){if(r.value===sel.value)r.checked=true;});},true);function syncDropdowns(){document.querySelectorAll('.ctm-option-2-main select').forEach(function(sel){hiddenRadios(sel).forEach(function(r){if(r.checked&&sel.value!==r.value)sel.value=r.value;});});}document.addEventListener('DOMContentLoaded',syncDropdowns);window.addEventListener('pageshow',syncDropdowns);})();